import React, { memo, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setListSort } from 'app/modules/tags'
import { get } from 'app/api/tags'
import Content from 'app/components/Content'
import Spinner from 'app/components/Spinner'
import TableTh from 'app/components/Table/TableTh'
import Pagination from 'app/components/Pagination'

const Tags = () => {
  const dispatch = useDispatch()
  const { sort, asc } = useSelector(state => state.tags)
  const [tags, setTags] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [skip, setSkip] = useState(0)
  const limit = 50

  useEffect(() => {
    setLoading(true)
    get({ skip, limit, sort, asc }).then(response => {
      setTotal(response.data.total)
      setTags(response.data.tags)
      setLoading(false)
    })
  }, [skip, limit, sort, asc])

  const handleSort = sort => {
    dispatch(setListSort({ sort, asc: !asc }))
  }

  return (
    <Content>
      <h4 className="font-weight-bold py-3 mb-1">
        <span className="text-muted font-weight-light">Lista /</span> Tags
      </h4>

      {loading && <Spinner />}
      <div className="card">
        <table className="table card-table">
          <thead className="thead-light">
            <tr>
              <th>
                <TableTh
                  title={'Nome'}
                  sort={sort === '_id'}
                  asc={asc}
                  onClick={() => handleSort('_id')}
                />
              </th>
              <th>
                <TableTh
                  title={'Publicações'}
                  sort={sort === 'posts'}
                  asc={asc}
                  onClick={() => handleSort('posts')}
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {tags.map(tag => {
              return (
                <tr key={tag.name}>
                  <td>{tag.name}</td>
                  <td>{tag.posts}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>

      <Pagination
        total={total}
        skip={skip}
        limit={limit}
        onClick={({ skip }) => setSkip(skip)}
      />
    </Content>
  )
}

export default memo(Tags)
